export let api
export let web
export let fls

let href = location.href
if (href.indexOf('10.193.144.67') !== -1) {
  api = 'http://10.193.144.67:8000'
  web = 'http://10.193.144.67:8000'
  fls = 'http://10.193.144.67:8000'
} else if (href.indexOf('192.168.163.167') !== -1) {
  api = 'http://192.168.163.167:8000'
  web = 'http://192.168.163.167:8000'
  fls = 'http://192.168.163.167:8000'
} else if (href.indexOf('12.8.1.67') !== -1) {
  api = 'http://12.8.1.67:8000'
  web = 'http://12.8.1.67:8000'
  fls = 'http://12.8.1.67:8000'
}  else if (href.indexOf('12.8.1.72') !== -1) {
  api = 'http://12.8.1.72:8000'
  web = 'http://12.8.1.72:8000'
  fls = 'http://12.8.1.72:8000'
} else if (href.indexOf('tj-cg.btzh.net') !== -1) {
  api = 'https://tj-cg.btzh.net:4443'
  web = 'https://tj-cg.btzh.net:4443'
  fls = 'https://tj-cg.btzh.net:4443'
} else if (href.indexOf('cg-manage.btzh.net') !== -1) {
  api = 'http://cg-manage.btzh.net:4443'
  web = 'http://cg-manage.btzh.net:4443'
  fls = 'http://cg-manage.btzh.net:4443'
} else if (href.indexOf('117.50.47.44') !== -1) {
  api = 'http://117.50.47.44:8000'
  web = 'http://117.50.47.44:8000'
  fls = 'http://117.50.47.44:8000'
} else if (href.indexOf('218.69.98.146') !== -1) {
  api = 'http://218.69.98.146:8000'
  web = 'http://218.69.98.146:8000'
  fls = 'http://218.69.98.146:8000'
} else if (href.indexOf('111.30.97.39') !== -1) {
  api = 'http://111.30.97.39:10017'
  web = 'http://111.30.97.39:10017'
  fls = 'http://111.30.97.39:10017'
} else if (href.indexOf('172.16.151.193') !== -1) {
  api = 'http://172.16.151.193:8000'
  web = 'http://172.16.151.193:8000'
  fls = 'http://172.16.151.193:8000'
} else if(href.indexOf('nh-cg.btzh.net') !== -1){
  api = 'https://nh-cg.btzh.net:4443'
  web = 'https://nh-cg.btzh.net:4443'
  fls = 'https://nh-cg.btzh.net:4443'
} else if(href.indexOf('tdk-cg.smej.com.cn') !== -1){
  api = 'https://tdk-cg.smej.com.cn:4443'
  web = 'https://tdk-cg.smej.com.cn:4443'
  fls = 'https://tdk-cg.smej.com.cn:4443'
} else {
  api = 'http://localhost:8081'
  web = 'http://localhost:9091'
  fls = 'http://cg-manage.btzh.net:4443'
}

// 模型、动态表单数据源、API数据源和API的访问控制类型
export const acTypes = [{
  key: 'PERMISSION_REQUIRED',
  label: '需要鉴权'
}, {
  key: 'PERMISSION_LESS',
  label: '不需要鉴权(但需要认证)'
}, {
  key: 'AUTHENTICATION_LESS',
  label: '无需认证(更无需鉴权)'
}]
